import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件

export default {
  name: 'SelectFileModal',
  data () {
    return {
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: true,
      // 查询条件
      tableQueryParams: {
        pageNum: 1,
        pageSize: 10
      },
      // 表格选中记录数组
      tableSelectedIndexs: [],
      tableSelectedNames: []
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    selectedFileIndexs: {
      type: Array
    }
  },
  mixins: [
    convertorMixin
  ],
  mounted() {
    this.tableData = [{id: 1, name: '文件1', format: 'mp3', size: '4MB', index: 0},
      {id: 2, name: '文件2', format: 'mp3', size: '4MB', index: 1}]
    this.tableTotalRow = this.tableData.length

    // 在组件中使用$ref，要求使用$nextTick，否则出现未定义对象访问
    this.$nextTick(() => {
      if (this.selectedFileIndexs.length > 0) {
        // 恢复上一次选中状态
        this.tableData.forEach((item, index) => {
          if (this.selectedFileIndexs.indexOf(index) >= 0) {
            this.$refs.table.toggleRowSelection(item, true) // 该操作后自动更新tableSelectedIds等变量
          }
        })
      }
    })
  },
  methods: {
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIndexs = selection.map(item => item.index)
      this.tableSelectedNames = selection.map(item => item.name)
    },
    // 分页
    handleTableCurrentChange (val) {
      this.tableQueryParams.pageNum = val
    },
    // 提交新增记录
    handleModalSubmit () {
      this.$emit('submit', this.tableSelectedIndexs, this.tableSelectedNames)
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/BroadcastSystem/selectFileModal/SelectFileModal.js